import type { ReactNode } from 'react';
import { X } from 'lucide-react';

export function PageHeader({ title, subtitle, actions }: { title: string; subtitle: string; actions?: ReactNode }) {
  return <div className="head"><div><h1>{title}</h1><div className="sub">{subtitle}</div></div>{actions && <div className="head-actions">{actions}</div>}</div>;
}

export function Stats({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`stats ${className}`}>{children}</div>;
}

export function Stat({ label, value, note, tone = '' }: { label: string; value: ReactNode; note: ReactNode; tone?: string }) {
  return <div className="stat"><div className="stat-label">{label}</div><div className={`stat-value ${tone}`}>{value}</div><div className="stat-change">{note}</div></div>;
}

export function Panel({ title, subtitle, actions, children, className = '' }: { title?: string; subtitle?: string; actions?: ReactNode; children: ReactNode; className?: string }) {
  return <div className={`panel ${className}`}>{(title || actions) && <div className="panel-head"><div><h2>{title}</h2>{subtitle && <div className="sub">{subtitle}</div>}</div>{actions}</div>}{children}</div>;
}

export function Loading({ label = '正在读取数据…' }: { label?: string }) { return <div className="loading"><span className="spinner" />{label}</div>; }
export function Empty({ label = '暂无数据' }: { label?: string }) { return <div className="empty">{label}</div>; }
export function ErrorState({ message, retry }: { message: string; retry: () => void }) { return <div className="error-state"><b>数据读取失败</b><span>{message}</span><button className="secondary" onClick={retry}>重新加载</button></div>; }

export function Modal({ open, title, children, footer, onClose, wide = false }: { open: boolean; title: string; children: ReactNode; footer: ReactNode; onClose: () => void; wide?: boolean }) {
  if (!open) return null;
  return <div className="modal-backdrop show" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className={`modal ${wide ? 'modal-wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
      <div className="modal-head"><h2>{title}</h2><button className="icon-button" onClick={onClose} aria-label="关闭"><X size={18} /></button></div>
      <div className="modal-body">{children}</div>
      <div className="modal-foot">{footer}</div>
    </section>
  </div>;
}

export function Field({ label, children }: { label: string; children: ReactNode }) { return <label className="field"><span>{label}</span>{children}</label>; }

export function Badge({ children, tone = '' }: { children: ReactNode; tone?: string }) { return <span className={`badge ${tone}`}>{children}</span>; }

export function formatTime(value: unknown) {
  if (!value) return '--';
  return String(value).replace('T', ' ').slice(0, 19);
}

export const number = (value: unknown, digits = 0) => Number(value ?? 0).toLocaleString('zh-CN', { minimumFractionDigits: digits, maximumFractionDigits: digits });
